
export enum Platform {
    BIDFOOD = 'bidfood',
    GNB = 'gnb',
    DZW = 'dzw',
    VANGELDER = 'vangelder',
    SLIGRO = 'sligro',
    DUNYONG = 'dunyong',
    TONKONIJN = 'tonkonijn',
    YAMA = 'yama',
    BANKETBAKKERIJ = 'banketbakkerij',
    OTELLI = 'otelli',
    JONGVADER = 'jongvader',
    GEBOGELATO = 'gebogelato',
    KWASTWIJNKOPERS = 'kwastwijnkopers',
    VINVIN = 'vinvin',
    NICETOMEAT = 'nicetomeat',
    FIXFISCH = 'fixfisch',
    RUNGIS = 'rungis',
    CHEFSFARM = 'chefsfarm',
    HANOS = 'hanos',
    RIJPELAAL = 'rijpelaal',
    ZUIVER = 'zuiver',
    DEBERGSECAVE = 'debergsecave',
    HYSCON = 'hyscon',
    RIJNMONDGAS = 'rijnmondgas',
    WINTERHALTER = 'winterhalter',
    EUROFINS = 'eurofins',
    KOELMONTEUR = 'koelmonteur',
    BRANDINGCLUB = 'brandingclub',
    WHISKEYSITE = 'whiskysite',
    EVIDES = 'evides',
    UPTA = 'upta',
    WINTAX = 'wintax',
    VERISURE = 'verisure',
    KIYA = 'kiya',
    VATEX = 'vatex',
    ENECO = 'eneco',
    ANY_INVOICE = 'any_invoice',
    DRANKDOZIJN = 'drankdozijn',
    LEXCEPTION = 'lexception',
    SWINKELS = 'swinkels',
    BOURGOGNEEXPRESS = 'bourgogneexpress',
    NOTENFABRIEK = 'notenfabriek',
    FOURCROY = 'fourcroy',
    BUONAPPETITO = 'buonappetito',
    NITROBREW = 'nitrobrew',
    RIGHTSPIRITS = 'rightspirits',
    SIDHU = 'sidhu',
    ILLY = 'illy',
    DEGROOTEDELGEBAK = 'degrootedelgebak',
    EUROPASTRY = 'europastry',
    KAASATELIER = 'kaasatelier',
    HEINEKEN = 'heineken',
    JORDYSBAKERY = 'jordysbakery',
    PATISSERIEBONDSMOLDERS = 'patisseriebondsmolders',
    SCHMIDTZEEVIS = 'schmidtzeevis',
    VHCJONGENS = 'vhcjongens',
    GRAPEDISTRICT = 'grapedistrict',
    STAFFHORST = 'staffhorst',
    EXCLUSIVELABELBENELUX = 'exclusivelabelbenelux',
    MARCKROONWIJN = 'marckroonwijn',
    LFE = 'lfe',
    MOESTUINVOLLENHOVEN = 'moestuinvollenhoven',
    PASTANOBILE = 'pastanobile',
    JANSONDRANKEN = 'jansondranken',
    LINDSCHOTENDRINK = 'lindschotendrink',
    FOODSTEPS = 'foodsteps',
    BOTTLEBUSINESS = 'bottlebusiness',
    DRANKENHANDEL = 'drankenhandel',
    MANETTI = 'manetti',
    ZEECHOCOLATE = 'zeechocolate',
    SANTASKOFFIE = 'santaskoffie',
    CEESVANNOORDWIJN = 'ceesvannoordwijn',
    SANDERSWIJNKOPERS = 'sanderswijnkopers',
    ALTSEAFOOD = 'altseafood',
    BJDELOGIE = 'bjdelogie',
    HOUSEOFCAVIAR = 'houseofcaviar',
    CLAUDIA = 'claudia',
    DVINE = 'dvine',
    VLAAMSCHBROODHUYS = 'vlaamschbroodhuys',
    BROUWERIJNOORDT = 'brouwerijnoordt',
    DEKOEKFABRIEK = 'dekoekfabriek',
    MINZEVENIJS = 'minzevenijs',
    LOUI = 'loui',
    KOEKTAILS = 'koektails',
    CHOCOSEUM = 'chocoseum',
    NOORDMANWIJNIMPORT = 'noordmanwijnimport',
    TASTETREE = 'tastetree',
    DAMMAN = 'damman',
    KARELVDVORM = 'karelvdvorm',
    TREUREN = 'treuren',
    LINSCHOTEN = 'linschoten',
    CASARON = 'casaron',
    PROPERPRODUCTS = 'properproducts',
    NESPRESSO = 'nespresso',
    VERBUNTVERLINDEN = 'verbuntverlinden',
    KOBIER = 'kobier',
    STADSHAVENBROUWERIJ = 'stadshavenbrouwerij',
    KEMMEWINES = 'kemmewines',
    MOETHENNESSY = 'moethennessy',
    JOUWGROENTEMAN = 'jouwgroenteman',
    DELICATEZZEDITALIA = 'delicatezzeditalia',
    GOLDTDRINKS = 'goldtdrinks',
    LAMUSE = 'lamuse',
    VETLAZY = 'vetlazy',
    IANENWIJN = 'ianenwijn',
    LAPROSCIUTTERIA = 'laprosciutteria',
    WINESPIRITS = 'winespirits',
    LASALUTE = 'lasalute',
    DEBRUIJN = 'debruijn',
    VINITES = 'vinites',
    BOLOMEY = 'bolomey',
    VLECK = 'vleck',
    JOKA = 'joka',
    DEKONINGVLEES = 'dekoningvlees',
    CORNYBAKERS = 'cornybakers',
    GIOEMPANADAS = 'gioempanadas',
    MANMETBRILKOFFIE = 'manmetbrilkoffie',
    HAVEAFEW = 'haveafew',
    SLAGERIJOOTEMAN = 'slagerijooteman',
    AAPNOOTBROOD = 'aapnootbrood',
    SCANWIC = 'scanwic',
    DEWEERT = 'deweert',
    KOMPAAN = 'kompaan',
    ICEFACTORY = 'icefactory',
    LINDENHOFF = 'lindenhoff',
    EBO = 'ebo',
    FRESHFOOD_DH = 'freshfood_dh',
    RUYKEN = 'ruyken',
    FILTA = 'filta',
    ESPRESSO_SW = 'espresso_sw',
    VANHATTEN = 'vanhatten',
    APS = 'aps',
    BEVENCO = 'bevenco',
    SEBCOCKTAILS = 'sebcocktails',
    ILOVECANNOLI = 'ilovecannoli',
    HORECAGOEDKOOP = 'horecagoedkoop',
    HORECAKING = 'horecaking',
    ALBERTHEIN = 'alberthein',
    TAKEAWARE = 'takeaware',
    JESSEDELICATESSE = 'jessedelicatesse',
    PUREMATCHA = 'purematcha',
    MAISONROUTIN = 'maisonroutin',
    BESTBREADBOBA = 'bestbreadboba',
    ANDREKERSTENS = 'andrekerstens',
    FILIUSKAAS = 'filiuskaas',
    VANILLAVENTURE = 'vanillaventure',
    GREENFRESHFOOD = 'greenfreshfood',
    ABINBEV = 'abinbev',
    DEGOUDENTON = 'degoudenton',
    VULCAANBIER = 'vulcaanbier',
    NRBC = 'nrbc',
    SENZATEA = 'senzatea',
    HOECKSEVIS = 'hoecksevis',
    FROBEL = 'frobel',
    IJSENIJSKOUD = 'ijsenijskoud',
    DEKLOKDRANKEN = 'deklokdranken',
    RELLMANFOODS = 'rellmanfoods',
    BERGFOOD = 'bergfood',
    CAVINOIR = 'cavinoir',
    PIEKSMANWIJN = 'pieksmanwijn',
    DEAMBACHTERIE = 'deambachterie',
    DRIESSENFOOD = 'driessenfood',
    DRINKSFROMJAPAN = 'drinksfromjapan',
    BEMAKERS = 'bemakers',
    MARIUSWIJNSAKE = 'mariuswijnsake',
    BARTSBOTTLES = 'bartsbottles',
    BRONWIJN = 'bronwijn',
    DORSTLUST = 'dorstlust',
    FULLCIRCLE = 'fullcircle',
    JANVANAS = 'janvanas',
    DRTRADING = 'drtrading',
    DASBROT = 'dasbrot',
    QSTA = 'qsta',
    OLLECOBUNGE = 'ollecobunge',
    SMITSDELICIOUS = 'smitsdelicious',
    DUDOK = 'dudok',
    WESTLANDPEPPERS = 'westlandpeppers',
    KOEKELA = 'koekela',
    VANDEBAKKER = 'vandebakker',
    KAAPSEBROUWERS = 'kaapsebrouwers',
    STATIONBERGWEG = 'stationbergweg',
    KOFFIEKOMPAAN = 'koffiekompaan',
    DUTCHWASABI = 'dutchwasabi',
    WIJNHANDELHERMAN = 'wijnhandelherman',
    PROFILGREC = 'profilgrec',
    JFCHOLLAND = 'jfcholland',
    JOSGLAS = 'josglas',
    LOCALHARVEST = 'localharvest',
    KAASFORT = 'kaasfort',
    GUILLAUME = 'guillaume',
    BINSBERGEN = 'binsbergen',
    QCULINAIR = 'qculinair',
    HOLLANDVIS = 'hollandvis',
    EUROSLAGERIJGRIEVING = 'euroslagerijgrieving',
    NATURALIA = 'naturalia',
    SAKEBASE = 'sakebase',
    CELLARMASTERS = 'cellarmasters',
    DRONK = 'dronk',
    INTERFASTFOOD = 'interfastfood',
    KRAAN = 'kraan',
    HICRET = 'hicret',
    KOYLU = 'koylu',
    AVO = 'avo',
    IRANBEZORGER = 'iranbezorger',
    ANTEP = 'antep',
    PEEZE = 'peeze',
    COCKTAILUNLIMITED = 'cocktailunlimited',
    COOKBOON = 'cookboon',
    VANLEERSUM = 'vanleersum',
    BAGHRIR = 'baghrir',
    LAKARUSCH = 'lakarusch',
    VHCKREKO = 'vhckreko',
    FONTIJN = 'fontijn',
    VERHOEK = 'verhoek',
    SEAFOODCENTRE = 'seafoodcentre',
    ALTINPETEK = 'altinpetek',
    QUEBRACHO = 'quebracho',
}

export namespace Platform {
    export function fromString(s: string): Platform {
      switch (s.toLowerCase()) {
        case Platform.BIDFOOD:
          return Platform.BIDFOOD
        case Platform.GNB:
          return Platform.GNB
        case Platform.DZW:
          return Platform.DZW
        case Platform.VANGELDER:
          return Platform.VANGELDER
        case Platform.SLIGRO:
          return Platform.SLIGRO
        case Platform.DUNYONG:
          return Platform.DUNYONG
        case Platform.TONKONIJN:
          return Platform.TONKONIJN
        case Platform.YAMA:
          return Platform.YAMA
        case Platform.BANKETBAKKERIJ:
          return Platform.BANKETBAKKERIJ
        case Platform.OTELLI:
          return Platform.OTELLI
        case Platform.JONGVADER:
          return Platform.JONGVADER
        case Platform.GEBOGELATO:
          return Platform.GEBOGELATO
        case Platform.KWASTWIJNKOPERS:
          return Platform.KWASTWIJNKOPERS
        case Platform.VINVIN:
          return Platform.VINVIN
        case Platform.NICETOMEAT:
          return Platform.NICETOMEAT
        case Platform.FIXFISCH:
          return Platform.FIXFISCH
        case Platform.RUNGIS:
          return Platform.RUNGIS
        case Platform.CHEFSFARM:
          return Platform.CHEFSFARM
        case Platform.HANOS:
          return Platform.HANOS
        case Platform.RIJPELAAL:
          return Platform.RIJPELAAL
        case Platform.ZUIVER:
          return Platform.ZUIVER
        case Platform.DEBERGSECAVE:
          return Platform.DEBERGSECAVE
        case Platform.HYSCON:
          return Platform.HYSCON
        case Platform.RIJNMONDGAS:
          return Platform.RIJNMONDGAS
        case Platform.WINTERHALTER:
          return Platform.WINTERHALTER
        case Platform.EUROFINS:
          return Platform.EUROFINS
        case Platform.KOELMONTEUR:
          return Platform.KOELMONTEUR
        case Platform.BRANDINGCLUB:
          return Platform.BRANDINGCLUB
        case Platform.UPTA:
          return Platform.UPTA
        case Platform.WINTAX:
          return Platform.WINTAX
        case Platform.VERISURE:
          return Platform.VERISURE
        case Platform.KIYA:
          return Platform.KIYA
        case Platform.VATEX:
          return Platform.VATEX
        case Platform.ENECO:
          return Platform.ENECO
        case Platform.WHISKEYSITE:
          return Platform.WHISKEYSITE
        case Platform.EVIDES:
          return Platform.EVIDES
        case Platform.ANY_INVOICE:
          return Platform.ANY_INVOICE
        case Platform.DRANKDOZIJN:
          return Platform.DRANKDOZIJN
        case Platform.FOURCROY:
          return Platform.FOURCROY
        case Platform.SWINKELS:
          return Platform.SWINKELS
        case Platform.BOURGOGNEEXPRESS:
          return Platform.BOURGOGNEEXPRESS
        case Platform.NOTENFABRIEK:
          return Platform.NOTENFABRIEK
        case Platform.BUONAPPETITO:
          return Platform.BUONAPPETITO
        case Platform.LEXCEPTION:
          return Platform.LEXCEPTION
        case Platform.NITROBREW:
          return Platform.NITROBREW
        case Platform.RIGHTSPIRITS:
          return Platform.RIGHTSPIRITS
        case Platform.SIDHU:
          return Platform.SIDHU
        case Platform.ILLY:
          return Platform.ILLY
        case Platform.DEGROOTEDELGEBAK:
          return Platform.DEGROOTEDELGEBAK
        case Platform.EUROPASTRY:
          return Platform.EUROPASTRY
        case Platform.KAASATELIER:
          return Platform.KAASATELIER
        case Platform.HEINEKEN:
          return Platform.HEINEKEN
        case Platform.PATISSERIEBONDSMOLDERS:
          return Platform.PATISSERIEBONDSMOLDERS
        case Platform.JORDYSBAKERY:
          return Platform.JORDYSBAKERY
        case Platform.SCHMIDTZEEVIS:
          return Platform.SCHMIDTZEEVIS
        case Platform.VHCJONGENS:
          return Platform.VHCJONGENS
        case Platform.JANSONDRANKEN:
          return Platform.JANSONDRANKEN
        case Platform.GRAPEDISTRICT:
          return Platform.GRAPEDISTRICT
        case Platform.STAFFHORST:
          return Platform.STAFFHORST
        case Platform.EXCLUSIVELABELBENELUX:
          return Platform.EXCLUSIVELABELBENELUX
        case Platform.MARCKROONWIJN:
          return Platform.MARCKROONWIJN
        case Platform.LFE:
          return Platform.LFE
        case Platform.PASTANOBILE:
          return Platform.PASTANOBILE
        case Platform.MOESTUINVOLLENHOVEN:
          return Platform.MOESTUINVOLLENHOVEN
        case Platform.LINDSCHOTENDRINK:
          return Platform.LINDSCHOTENDRINK
        case Platform.FOODSTEPS:
          return Platform.FOODSTEPS
        case Platform.BOTTLEBUSINESS:
          return Platform.BOTTLEBUSINESS
        case Platform.DRANKENHANDEL:
          return Platform.DRANKENHANDEL
        case Platform.MANETTI:
          return Platform.MANETTI
        case Platform.ZEECHOCOLATE:
          return Platform.ZEECHOCOLATE
        case Platform.SANTASKOFFIE:
          return Platform.SANTASKOFFIE
        case Platform.CEESVANNOORDWIJN:
          return Platform.CEESVANNOORDWIJN
        case Platform.SANDERSWIJNKOPERS:
          return Platform.SANDERSWIJNKOPERS
        case Platform.ALTSEAFOOD:
          return Platform.ALTSEAFOOD
        case Platform.BJDELOGIE:
          return Platform.BJDELOGIE
        case Platform.HOUSEOFCAVIAR:
          return Platform.HOUSEOFCAVIAR
        case Platform.CLAUDIA:
          return Platform.CLAUDIA
        case Platform.DVINE:
          return Platform.DVINE
        case Platform.VLAAMSCHBROODHUYS:
          return Platform.VLAAMSCHBROODHUYS
        case Platform.BROUWERIJNOORDT:
          return Platform.BROUWERIJNOORDT
        case Platform.DEKOEKFABRIEK:
          return Platform.DEKOEKFABRIEK
        case Platform.MINZEVENIJS:
          return Platform.MINZEVENIJS
        case Platform.LOUI:
          return Platform.LOUI
        case Platform.CHOCOSEUM:
          return Platform.CHOCOSEUM
        case Platform.NOORDMANWIJNIMPORT:
          return Platform.NOORDMANWIJNIMPORT
        case Platform.KOEKTAILS:
          return Platform.KOEKTAILS
        case Platform.TASTETREE:
          return Platform.TASTETREE
        case Platform.DAMMAN:
          return Platform.DAMMAN
        case Platform.KARELVDVORM:
          return Platform.KARELVDVORM
        case Platform.TREUREN:
          return Platform.TREUREN
        case Platform.LINSCHOTEN:
          return Platform.LINSCHOTEN
        case Platform.CASARON:
          return Platform.CASARON
        case Platform.PROPERPRODUCTS:
          return Platform.PROPERPRODUCTS
        case Platform.NESPRESSO:
          return Platform.NESPRESSO
        case Platform.VERBUNTVERLINDEN:
          return Platform.VERBUNTVERLINDEN
        case Platform.KOBIER:
          return Platform.KOBIER
        case Platform.STADSHAVENBROUWERIJ:
          return Platform.STADSHAVENBROUWERIJ
        case Platform.KEMMEWINES:
          return Platform.KEMMEWINES
        case Platform.MOETHENNESSY:
          return Platform.MOETHENNESSY
        case Platform.JOUWGROENTEMAN:
          return Platform.JOUWGROENTEMAN
        case Platform.DELICATEZZEDITALIA:
          return Platform.DELICATEZZEDITALIA
        case Platform.GOLDTDRINKS:
          return Platform.GOLDTDRINKS
        case Platform.LAMUSE:
          return Platform.LAMUSE
        case Platform.VETLAZY:
          return Platform.VETLAZY
        case Platform.IANENWIJN:
          return Platform.IANENWIJN
        case Platform.LAPROSCIUTTERIA:
          return Platform.LAPROSCIUTTERIA
        case Platform.WINESPIRITS:
          return Platform.WINESPIRITS
        case Platform.LASALUTE:
          return Platform.LASALUTE
        case Platform.DEBRUIJN:
          return Platform.DEBRUIJN
        case Platform.VINITES:
          return Platform.VINITES
        case Platform.BOLOMEY:
          return Platform.BOLOMEY
        case Platform.VLECK:
          return Platform.VLECK
        case Platform.JOKA:
          return Platform.JOKA
        case Platform.DEKONINGVLEES:
          return Platform.DEKONINGVLEES
        case Platform.CORNYBAKERS:
          return Platform.CORNYBAKERS
        case Platform.GIOEMPANADAS:
          return Platform.GIOEMPANADAS
        case Platform.MANMETBRILKOFFIE:
          return Platform.MANMETBRILKOFFIE
        case Platform.HAVEAFEW:
          return Platform.HAVEAFEW
        case Platform.SLAGERIJOOTEMAN:
          return Platform.SLAGERIJOOTEMAN
        case Platform.AAPNOOTBROOD:
          return Platform.AAPNOOTBROOD
        case Platform.SCANWIC:
          return Platform.SCANWIC
        case Platform.DEWEERT:
          return Platform.DEWEERT
        case Platform.KOMPAAN:
          return Platform.KOMPAAN
        case Platform.ICEFACTORY:
          return Platform.ICEFACTORY
        case Platform.LINDENHOFF:
          return Platform.LINDENHOFF
        case Platform.EBO:
          return Platform.EBO
        case Platform.FRESHFOOD_DH:
          return Platform.FRESHFOOD_DH
        case Platform.RUYKEN:
          return Platform.RUYKEN
        case Platform.FILTA:
          return Platform.FILTA
        case Platform.ESPRESSO_SW:
          return Platform.ESPRESSO_SW
        case Platform.VANHATTEN:
          return Platform.VANHATTEN
        case Platform.APS:
          return Platform.APS
        case Platform.SEBCOCKTAILS:
          return Platform.SEBCOCKTAILS
        case Platform.BEVENCO:
          return Platform.BEVENCO
        case Platform.ILOVECANNOLI:
          return Platform.ILOVECANNOLI
        case Platform.HORECAGOEDKOOP:
          return Platform.HORECAGOEDKOOP
        case Platform.HORECAKING:
          return Platform.HORECAKING
        case Platform.ALBERTHEIN:
          return Platform.ALBERTHEIN
        case Platform.TAKEAWARE:
          return Platform.TAKEAWARE
        case Platform.JESSEDELICATESSE:
          return Platform.JESSEDELICATESSE
        case Platform.PUREMATCHA:
          return Platform.PUREMATCHA
        case Platform.MAISONROUTIN:
          return Platform.MAISONROUTIN
        case Platform.BESTBREADBOBA:
          return Platform.BESTBREADBOBA
        case Platform.ANDREKERSTENS:
          return Platform.ANDREKERSTENS
        case Platform.FILIUSKAAS:
          return Platform.FILIUSKAAS
        case Platform.VANILLAVENTURE:
          return Platform.VANILLAVENTURE
        case Platform.GREENFRESHFOOD:
          return Platform.GREENFRESHFOOD
        case Platform.ABINBEV:
          return Platform.ABINBEV
        case Platform.DEGOUDENTON:
          return Platform.DEGOUDENTON
        case Platform.VULCAANBIER:
          return Platform.VULCAANBIER
        case Platform.NRBC:
          return Platform.NRBC
        case Platform.SENZATEA:
          return Platform.SENZATEA
        case Platform.HOECKSEVIS:
          return Platform.HOECKSEVIS
        case Platform.FROBEL:
          return Platform.FROBEL
        case Platform.IJSENIJSKOUD:
          return Platform.IJSENIJSKOUD
        case Platform.DEKLOKDRANKEN:
          return Platform.DEKLOKDRANKEN
        case Platform.RELLMANFOODS:
          return Platform.RELLMANFOODS
        case Platform.BERGFOOD:
          return Platform.BERGFOOD
        case Platform.CAVINOIR:
          return Platform.CAVINOIR
        case Platform.PIEKSMANWIJN:
          return Platform.PIEKSMANWIJN
        case Platform.DEAMBACHTERIE:
          return Platform.DEAMBACHTERIE
        case Platform.DRIESSENFOOD:
          return Platform.DRIESSENFOOD
        case Platform.DRINKSFROMJAPAN:
          return Platform.DRINKSFROMJAPAN
        case Platform.BEMAKERS:
          return Platform.BEMAKERS
        case Platform.MARIUSWIJNSAKE:
          return Platform.MARIUSWIJNSAKE
        case Platform.BARTSBOTTLES:
          return Platform.BARTSBOTTLES
        case Platform.BRONWIJN:
          return Platform.BRONWIJN
        case Platform.DORSTLUST:
          return Platform.DORSTLUST
        case Platform.FULLCIRCLE:
          return Platform.FULLCIRCLE
        case Platform.JANVANAS:
          return Platform.JANVANAS
        case Platform.DRTRADING:
          return Platform.DRTRADING
        case Platform.DASBROT:
          return Platform.DASBROT
        case Platform.QSTA:
          return Platform.QSTA
        case Platform.OLLECOBUNGE:
          return Platform.OLLECOBUNGE
        case Platform.SMITSDELICIOUS:
          return Platform.SMITSDELICIOUS
        case Platform.DUDOK:
          return Platform.DUDOK
        case Platform.WESTLANDPEPPERS:
          return Platform.WESTLANDPEPPERS
        case Platform.KOEKELA:
          return Platform.KOEKELA
        case Platform.VANDEBAKKER:
          return Platform.VANDEBAKKER
        case Platform.KAAPSEBROUWERS:
          return Platform.KAAPSEBROUWERS
        case Platform.STATIONBERGWEG:
          return Platform.STATIONBERGWEG
        case Platform.GUILLAUME:
          return Platform.GUILLAUME
        case Platform.EUROSLAGERIJGRIEVING:
          return Platform.EUROSLAGERIJGRIEVING
        case Platform.HOLLANDVIS:
          return Platform.HOLLANDVIS
        case Platform.QCULINAIR:
          return Platform.QCULINAIR
        case Platform.BINSBERGEN:
          return Platform.BINSBERGEN
        case Platform.KAASFORT:
          return Platform.KAASFORT
        case Platform.NATURALIA:
          return Platform.NATURALIA
        case Platform.LOCALHARVEST:
          return Platform.LOCALHARVEST
        case Platform.JOSGLAS:
          return Platform.JOSGLAS
        case Platform.PROFILGREC:
          return Platform.PROFILGREC
        case Platform.JFCHOLLAND:
          return Platform.JFCHOLLAND
        case Platform.KOFFIEKOMPAAN:
          return Platform.KOFFIEKOMPAAN
        case Platform.WIJNHANDELHERMAN:
          return Platform.WIJNHANDELHERMAN
        case Platform.DUTCHWASABI:
          return Platform.DUTCHWASABI
        case Platform.SAKEBASE:
          return Platform.SAKEBASE
        case Platform.CELLARMASTERS:
          return Platform.CELLARMASTERS
        case Platform.DRONK:
          return Platform.DRONK
        case Platform.INTERFASTFOOD:
          return Platform.INTERFASTFOOD
        case Platform.KRAAN:
          return Platform.KRAAN
        case Platform.HICRET:
          return Platform.HICRET
        case Platform.KOYLU:
          return Platform.KOYLU
        case Platform.AVO:
          return Platform.AVO
        case Platform.IRANBEZORGER:
          return Platform.IRANBEZORGER
        case Platform.ANTEP:
          return Platform.ANTEP
        case Platform.PEEZE:
          return Platform.PEEZE
        case Platform.COCKTAILUNLIMITED:
          return Platform.COCKTAILUNLIMITED
        case Platform.VANLEERSUM:
          return Platform.VANLEERSUM
        case Platform.COOKBOON:
          return Platform.COOKBOON
        case Platform.BAGHRIR:
          return Platform.BAGHRIR
        case Platform.LAKARUSCH:
          return Platform.LAKARUSCH
        case Platform.VHCKREKO:
          return Platform.VHCKREKO
        case Platform.FONTIJN:
          return Platform.FONTIJN
        case Platform.VERHOEK:
          return Platform.VERHOEK
        case Platform.SEAFOODCENTRE:
          return Platform.SEAFOODCENTRE
        case Platform.ALTINPETEK:
          return Platform.ALTINPETEK
        case Platform.QUEBRACHO:
          return Platform.QUEBRACHO
        default:
          throw new Error(`Unknown platform: ${s}`)
      }
    }
  }